import { z } from 'zod';
/**
 * The exact permission catalogue from `docs/02-DATA-MODEL.md` §3
 * ("Permission catalogue"). Closed union — guards reference these strings.
 */
export const PERMISSIONS = [
    'contract:read',
    'contract:write',
    'contract:delete',
    'site:read',
    'site:write',
    'site:delete',
    'zone:read',
    'zone:write',
    'zone:delete',
    'user:read',
    'user:write',
    'user:deactivate',
    'membership:read',
    'membership:write',
    'pin:reset',
    'device:reset',
    'user:unlock',
    'series:read',
    'series:write',
    'series:generate',
    'shift:read',
    'shift:write',
    'shift:assign',
    'shift:cancel',
    'punch:read',
    'punch:adjust',
    'exception:read',
    'exception:resolve',
    'timesheet:read',
    'timesheet:export',
    'audit:read',
    'settings:read',
    'settings:write',
    // Phase 5 (tasks, 2026-09-02, T-15). No third `task:assign`: assigning is a
    // write like any other, and nobody has asked for the split operationally.
    'task:read',
    'task:write',
];
export const PermissionSchema = z.enum(PERMISSIONS);
//# sourceMappingURL=permissions.js.map